import React from "react"
import {Link, graphql} from "gatsby"
import * as styles from "../../components/cases/cases.module.scss"

import Layout from "../../components/Layout"
import Quote from "../../components/content/Quote";
import CaseHero from "../../components/hero/CaseHero";
import BgBanner from "../../components/content/BgBanner";
import Content from "../../components/content/Content";
import ColumnContent from "../../components/content/ColumnContent";
import Contact from "../../components/content/Contact";

const CasePostTemplate = ({data: {previous, next, post}}) => {

    return (
        <Layout posttype={`cases`} seo={post.seo}>
            <CaseHero pageTitle={post.title} desc={post.content} content={post.caseDetails} tags={post.tags.nodes}
                      cats={post.categories.nodes}/>

            {post.imageBanner &&
                post.imageBanner.bannerdescription &&
                    <BgBanner content={post.imageBanner}/>
            }

            {post.standaardContent.defaultContent &&
            post.standaardContent.defaultContent.map((defaultContent, key) => {
                return <Content key={key} content={defaultContent}/>
            })
            }

            {post.columnContent.columnContent &&
            <ColumnContent content={post.columnContent.columnContent}/>
            }

            {post.caseDetails.quotes &&
            <Quote content={post.caseDetails.quotes}/>
            }
            <div className="grid-container-wrap">
                <hr/>
            </div>

            <nav className={styles.casesNav}>
                {previous ? (
                    <Link title={`Vorige case: ${previous.title}`} className={styles.casesNavPrev} to={previous.uri}
                          rel="prev">
                        <span>Vorige case<span className="sr-only">: {previous.title}</span></span>
                    </Link>
                ) : (
                    <Link to={``} className={`${styles.casesNavPrev} disabled`} rel="prev">
                        <span>Vorige case</span>
                    </Link>
                )
                }

                <Link title="Cases overzicht" className={styles.casesNavOverview} to={`/cases/`}>
                    <span>Cases overzicht</span>
                </Link>

                {next ? (
                    <Link title={`Volgende case: ${next.title}`} className={styles.casesNavNext} to={next.uri}
                          rel="next">
                        <span>Volgende case<span className="sr-only">: {next.title}</span></span>
                    </Link>
                ) : (
                    <Link to={``} className={`${styles.casesNavNext} disabled`} rel="next">
                        <span>Volgende case</span>
                    </Link>
                )
                }
            </nav>

            {post.contactCta &&
            <Contact content={post.contactCta}/>
            }
        </Layout>
    )
}

export default CasePostTemplate

export const pageQuery = graphql`query CaseById($id: String!, $previousPostId: String, $nextPostId: String) {
  post: wpCase(id: {eq: $id}) {
    id
    content
    title
    date(formatString: "DD MMMM, YYYY")
    seo {
      title
      metaDesc
      canonical
      metaKeywords
      metaRobotsNoindex
      metaRobotsNofollow
      opengraphTitle
      opengraphDescription
      opengraphType
    }
    caseDetails {
      casetitle
      website
      quotes {
        ... on WpQuote {
          id
          quotes {
            quote
            quoter
          }
        }
      }
      cooperation
      companyname
      assignment
    }
    featuredImage {
      node {
        altText
        localFile {
          childImageSharp {
            gatsbyImageData(quality: 100, placeholder: BLURRED, layout: FULL_WIDTH)
          }
        }
      }
    }
    quotes {
      quote
      quoter
    }
    imageBanner {
      bannercta {
        target
        title
        url
      }
      bannerdescription
      bannerimage {
        localFile {
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED, width: 10, layout: FULL_WIDTH)
          }
        }
      }
    }
    categories {
      nodes {
        diensten {
          nodes {
            uri
            title
          }
        }
        uri
        name
        slug
      }
    }
    standaardContent {
      defaultContent {
        contentCta {
          target
          url
          title
        }
        contentDescription
        contentTitle
        contentImage {
          localFile {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED, width: 797, placeholder: BLURRED)
            }
          }
        }
      }
    }
    columnContent {
      columnContent {
        contentCta {
          target
          title
          url
        }
        contentDescription
        contentTitle
      }
    }
    tags {
      nodes {
        slug
        name
        cases {
          nodes {
            uri
          }
        }
      }
    }
    contactCta {
      contactCta {
        target
        title
        url
      }
      description
      title
    }
  }
  previous: wpCase(id: {eq: $previousPostId}) {
    uri
    title
  }
  next: wpCase(id: {eq: $nextPostId}) {
    uri
    title
  }
}
`
